import wx from 'weixin-js-sdk';
import axios from "../axios/index.js";
import { getCookie } from "@/assets/utils/common.js"

const linkurl = (location.href.indexOf("active.feihe.com") >= 0 ? "https://active.feihe.com/" : "https://activeuat.feihe.com/") + "fission-video/fissionVideo?openId=" + getCookie("openId");
const shareImg = 'https://' + location.host + "/fissionVideo/static/shareimg.jpeg";

console.log(shareImg)

const jsApiList = ['hideMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage'];
//要用到微信API
export function getJSSDK(url, callback) {
    // 调用后台接口换取参数
    axios.get(process.env.VUE_APP_LOGOUT_URL + "/fission-video/fissionVideo/param", {
        params: {
            url: url,
            hideloading: true
        },
    }).then(res => {
        console.log(res);
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.obj.appId + "", // 必填，公众号的唯一标识
            timestamp: res.obj.timestamp + "", // 必填，生成签名的时间戳
            nonceStr: res.obj.nonceStr + "", // 必填，生成签名的随机串
            signature: res.obj.signature + "", // 必填，签名
            jsApiList: jsApiList, // 必填，需要使用的JS接口列表
        })
        wx.ready(function () {
            var options = {
                title: "传播爱，获大奖，请送我小心心！",
                link: linkurl,
                imgUrl: shareImg,
                desc: "飞鹤新鲜品鉴官接力战，千元大礼等你拿！",
                trigger: function trigger(res) { },
                success: function success(res) {
                    console.log('已分享');
                    callback();
                },
                cancel: function cancel(res) {
                    console.log('已取消');
                    callback();
                },
                fail: function fail(res) {
                    console.log(res, '成功')
                    alert(JSON.stringify(res));
                    callback();
                }
            }
            console.log(options)
            wx.onMenuShareTimeline(options);
            wx.onMenuShareAppMessage(options);
            wx.onMenuShareTimeline(options);
            // 批量隐藏功能按钮接口 "menuItem:share:appMessage", "menuItem:share:timeline",
            wx.hideMenuItems({
                menuList: ["menuItem:setFont", "menuItem:dayMode", "menuItem:nightMode", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:QZone", "menuItem:copyUrl", "menuItem:openWithQQBrowser", "menuItem:openWithSafari"]
            })
        })
        // wx.error(function (res) {
        //   console.log(res,'失败了')
        //   console.log(JSON.stringify(res) + "微信验证失败");
        //   alert(JSON.stringify(res)+"微信验证失败");
        // });
    })
}



// WEBPACK FOOTER //
// ./src/assets/utils/jssdk.js